export const TimezoneConstants = {
  americaToronto: 'America/Toronto',
  americaVancouver: 'America/Vancouver',
  americaEdmonton: 'America/Edmonton', 
  australiaSydney: 'Australia/Sydney',
  americaDenver: 'America/Denver'
};
